<ng-progress></ng-progress>

<div *ngIf="maintenancePlanned" [ngClass]="{'right_col_md': isToggle}">
  <ap-maintenance-banner></ap-maintenance-banner>
</div>

<div *ngIf="!maintenanceInProgress">
  <div class="container body">
    <div class="main_container">
      <div class="col-md-3 left_col menu_fixed" [ngClass]="{'menu_size_md': isToggle}">
        <app-menu [isToggle]='isToggle'></app-menu>
      </div>

      <!-- top navigation -->
      <div class="top_nav" [ngClass]="{'top_nav_md': isToggle}">
        <div class="nav_menu">
          <nav>
            <div class="nav toggle">
              <a id="menu_toggle" (click)="toggleNavSize()"><i class="fa fa-bars"></i></a>
            </div>

            <ul class="nav navbar-nav navbar-right">
              <li class="">
                <a href="javascript:void(0)" (click)="logout()" class="user-profile">
                  <i class="fa fa-sign-out"></i> {{ 'MENU.LOGOUT' | translate }}
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <!-- /top navigation -->

      <!-- page content -->
      <div class="right_col" [ngClass]="{'right_col_md': isToggle}" #content role="main">
        <router-outlet></router-outlet>
      </div>
      <!-- /page content -->

      <!-- footer content -->
      <footer>
        <div class="pull-right">{{ 'VERSION' | translate }} {{ appVersion }}</div>
        <div class="clearfix"></div>
      </footer>
      <!-- /footer content -->
    </div>
  </div>
</div>
<div *ngIf="maintenanceInProgress">
  <router-outlet></router-outlet>
</div>
<div class="modal-container"></div>
